import React from 'react';
import { Whisper } from 'rsuite';

export const WhisperWrapper = ({children, tooltip, show = false, props}) => {
    if (!show) {
        return children;
    }

    return (
        <Whisper {...props} speaker={tooltip}>
            {children}
        </Whisper>
    );
}